import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import IconArrowLeft from '@veneer/core/dist/scripts/icons/icon_arrow_left';
import IconChevronLeft from '@veneer/core/dist/scripts/icons/icon_chevron_left';

import DebugButton from '../DebugButton';

import { Heading, Title, Expand, TitleContainer, StyledHeader, LinkButton } from './Header.styles';

const Header = React.memo(props => {
  const [showReset, setShowReset] = useState(false);
  const isShowAllClicked = useRef(false);
  const {
    isShowAllEnabled,
    isResetEnabled,
    isMobile,
    headerText: { title: titleText, showAll: showAllText }
  } = props;

  const toggleResetButton = () => {
    setShowReset(!showReset);
    props.onDebugModeToggle(!showReset);
  };

  const onShowAll = () => {
    if (!isShowAllClicked.current) {
      isShowAllClicked.current = true;
      props.onShowAll();
      setTimeout(() => {
        isShowAllClicked.current = false;
      }, 1000);
    }
  };

  const header = props.theme.fullScreen ? (
    <StyledHeader
      dir={props.theme.dir}
      id='seeAll_header'
      $isMobile={isMobile}
      position='relative'
      theme={props.theme}
      leftArea={
        <LinkButton onClick={props.onBack} aria-label='Back' tabIndex='0' role='button'>
          {!props.isMobile ? (
            <IconArrowLeft color='colorGray8' filled data-testid='desktop_back' />
          ) : (
            <IconChevronLeft color='colorHpBlue6' filled data-testid='mobile_back' />
          )}
        </LinkButton>
      }
      centerArea={<span>{titleText}</span>}
      rightArea={<span></span>}
    />
  ) : (
    <Heading dir={props.theme.dir}>
      <TitleContainer>
        {isResetEnabled ? (
          <DebugButton toggle={toggleResetButton}>
            <Title id='cec_title' role='heading' aria-level='1'>
              {titleText}
            </Title>
          </DebugButton>
        ) : (
          <Title id='cec_title' role='heading' aria-level='1'>
            {titleText}
          </Title>
        )}
      </TitleContainer>
      <div>
        {showReset && (
          <Expand id='cec_reset_button' appearance='primary' onClick={props.onReset}>
            Reset
          </Expand>
        )}

        {isShowAllEnabled && (
          <Expand id='cec_showall_button' onClick={onShowAll}>
            {showAllText}
          </Expand>
        )}
      </div>
    </Heading>
  );

  return header;
});

Header.propTypes = {
  /**
   * Flag to show showall
   */
  isShowAllEnabled: PropTypes.bool,
  /**
   * Flag to show reset
   */
  isResetEnabled: PropTypes.bool,
  /**
   * Flag to show mobile header
   */
  isMobile: PropTypes.bool,
  /**
   * Strings to display in header
   */
  headerText: PropTypes.object,
  /**
   * Reset click handler
   */
  onReset: PropTypes.func,
  /**
   * showall click handler
   */
  onShowAll: PropTypes.func,
  /**
   * back click handler
   */
  onBack: PropTypes.func,
  /**
   * App theme
   */
  theme: PropTypes.object
};

Header.defaultProps = {
  onReset: () => {},
  onShowAll: () => {},
  onBack: () => {},
  isMobile: false,
  isShowAllEnabled: false,
  isResetEnabled: false,
  headerText: {},
  theme: { dir: 'ltr', fullScreen: false }
};

export default Header;
